import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Layout from './components/layout/Layout';
import AlumniLayout from './components/layout/AlumniLayout';
import AuthLayout from './components/layout/AuthLayout';
import HomePage from './pages/HomePage';
import SearchPage from './pages/SearchPage';
import LoginPage from './pages/LoginPage';
import GownRequestPage from './pages/GownRequestPage';
import PublicBooklets from './pages/PublicBooklets';
import AdminDashboard from './pages/AdminDashboard';
import PrivateRoute from './components/common/PrivateRoute';
import { AuthProvider } from './context/AuthContext';
import AlumniPage from './pages/AlumniPage';
import AlumniDetails from './pages/AlumniDetails';
import AlumniRegistration from './pages/AlumniRegistration';
import AlumniLogin from './pages/AlumniLogin';
import AlumniDashboard from './pages/AlumniDashboard';
import AlumniNomination from './pages/AlumniNomination';
import AlumniVote from './pages/AlumniVote';
import Vote from './pages/Vote';
import AlumniDirectory from './pages/AlumniDirectory';
import AlumniSettings from './pages/AlumniSettings';
import BlogPage from './pages/BlogPage';
import BlogPost from './pages/BlogPost';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes - With Layout */}
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/search" element={<Layout><SearchPage /></Layout>} />
          <Route path="/login" element={<Layout><LoginPage /></Layout>} />
          <Route path="/gown-request" element={<Layout><GownRequestPage /></Layout>} />
          <Route path="/booklets" element={<Layout><PublicBooklets /></Layout>} />
          <Route path="/alumni" element={<Layout><AlumniPage /></Layout>} />
          <Route path="/alumni/:id" element={<Layout><AlumniDetails /></Layout>} />
          
          {/* Alumni Auth Routes - No Sidebar */}
          <Route path="/alumni/register" element={<AuthLayout><AlumniRegistration /></AuthLayout>} />
          <Route path="/vote" element={<Layout><Vote /></Layout>} />
          <Route path="/alumni/login" element={<AuthLayout><AlumniLogin /></AuthLayout>} />
          
          {/* Alumni Dashboard Routes - With Sidebar */}
          <Route path="/alumni/dashboard" element={<AlumniLayout><AlumniDashboard /></AlumniLayout>} />
          <Route path="/alumni/directory" element={<AlumniLayout><AlumniDirectory /></AlumniLayout>} />
          <Route path="/alumni/settings" element={<AlumniLayout><AlumniSettings /></AlumniLayout>} />
          <Route path="/alumni/nomination" element={<AlumniLayout><AlumniNomination /></AlumniLayout>} />
          <Route path="/alumni/vote" element={<AlumniLayout><AlumniVote /></AlumniLayout>} />
          
          {/* Blog Routes */}
          <Route path="/blog" element={<Layout><BlogPage /></Layout>} />
          <Route path="/blog/:slug" element={<Layout><BlogPost /></Layout>} />
          
          {/* Admin Routes - No Layout, uses its own layout */}
          <Route path="/admin/*" element={
            <PrivateRoute>
              <AdminDashboard />
            </PrivateRoute>
          } />

          {/* Catch all - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </Router>
    </AuthProvider>
  );
}

export default App;
